import axios from 'axios';
import React, { useState, useMemo } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup } from 'reactstrap';
import { Label } from 'reactstrap'
import { environment } from '../../env';
import { successModalToggle, loaderAction } from '../../redux/actions/Index';
import ErrorComponents from '../errorComponents/ErrorComponents';
import { useEffect } from 'react';
import { PencilLine } from '@phosphor-icons/react';

const RegistrationModal = ({ datas, userLists, title, button, getAllUser }, ...props) => {
    const [modal, setModal] = useState(false);
    const [editt, setEdit] = useState(false)
    const [nameFilters, setNameFilters] = useState()
    const projectList = useSelector((state) => state?.ModalReducer?.projectList);
    const toggle = () => { setModal(!modal); setEdit(!editt) }
    const dispatch = useDispatch()
    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm();

    const userName = watch("username")
    const onSubmit = async (data) => {
        if (button == 'edit') {
            try {
                await axios.put(`${environment.baseUrl}editprofile/${datas?.user?.id}`, data).then((form) => {
                    if (form.data.code === 200) {
                        dispatch(successModalToggle());
                        getAllUser();
                        dispatch(loaderAction(false));
                        toggle();
                        reset();
                    }
                    else {
                        dispatch(loaderAction(false))
                        console.log(err);
                    }
                })
            }
            catch (err) {
                dispatch(loaderAction(false));
                console.log(err);
            }
        } else {
            if (userLists) {
                const NameFilter = userLists.filter((data, i) => {
                    return data?.user?.username.toUpperCase() === userName.toUpperCase()
                })
                if (NameFilter?.length > 0) {
                    setNameFilters("This username is already created...");
                    return
                }
                else {
                    setNameFilters("");
                }
            }
            dispatch(loaderAction(true))
            data.is_superuser = false
            try {
                await axios.post(`${environment.baseUrl}registration/`, data).then((form) => {
                    if (form.data.code === 200) {
                        dispatch(successModalToggle());
                        getAllUser();
                        dispatch(loaderAction(false));
                        toggle();
                        reset();
                    }
                    else {
                        dispatch(loaderAction(false))
                        console.log("err");
                    }
                })
            }
            catch (err) {
                dispatch(loaderAction(false));
                console.log(err);
            }
        }
    };
    // const getProjectData = () => {
    //     try {
    //         axios.get(`${environment.baseUrl}project/`).then(res => setProjectList(res?.data)).catch(res => {
    //             console.log("error", res);
    //         })
    //     }
    //     catch (err) {
    //         console.log(err);
    //     }
    // };
    const CancelButton = () => {
        toggle();
        reset();
        setNameFilters("");
    }

    useMemo(() => {
        if (button == 'edit') {
            reset({
                "first_name": datas?.user?.first_name,
                "last_name": datas?.user?.last_name,
                "username": datas?.user?.username,
                "email": datas?.user?.email,
                "role": datas?.role,
                "project": datas?.project?.id,
            })
        }
    }, [editt])

    // useEffect(() => {
    //     getProjectData()
    // }, [])


    return (
        <>
            {button != "edit" ? (
                <Button
                    onClick={toggle}
                    className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5"
                >
                    <span className="fs-3 d-flex gap-3 title-font-600 px-3">
                        Add New Employee
                    </span>
                </Button>
            ) : (
                <button
                    onClick={toggle}
                    className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' />
                </button>
            )}
            <Modal className='border-0' isOpen={modal} toggle={props.toggle} size="lg" centered>
                <ModalHeader className='bg-base-color ' ><span className='title-font-700 fs-36 text-base-white'>{title}</span></ModalHeader>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <ModalBody className='bg-background-color px-5'>
                        <div className="row">
                            <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start">
                                <Label htmlFor="first_name" className="title-font-500 fs-4 text-start text-black">
                                    Firstname *
                                </Label>
                                <input
                                    className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                                    id="first_name"

                                    {...register("first_name", {
                                        required: "Firstname is required *",
                                        pattern: {
                                            value: /^[a-zA-Z]+$/,
                                            message: "Enter characters only"
                                        }
                                    })}
                                    name="first_name"
                                    placeholder="FirstName..."
                                    type="text"
                                    autoComplete="off"
                                />
                                {errors.first_name && <ErrorComponents error={errors.first_name?.message} />}
                            </FormGroup>
                            <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start">
                                <Label htmlFor="last_name" className="title-font-500 fs-4 text-start text-black">
                                    Lastname *
                                </Label>
                                <input
                                    className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                                    id="last_name"
                                    {...register("last_name", {
                                        required: "Lastname is required *", pattern: {
                                            value: /^[a-zA-Z]+$/,
                                            message: "Enter characters only"
                                        }
                                    })}
                                    name="last_name"
                                    placeholder="LastName..."
                                    type="text"
                                />
                                {errors.last_name && <ErrorComponents error={errors.last_name?.message} />}
                            </FormGroup>
                            <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start">
                                <Label htmlFor="Username" className="title-font-500 fs-4 text-start text-black">
                                    Username *
                                </Label>
                                <input
                                    className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                                    id="username"
                                    {...register("username", { required: "Username is required *" })}
                                    name="username"
                                    placeholder="Enter Username..."
                                    type="email"
                                />
                                {errors.username && <ErrorComponents error={errors.username?.message} />}
                                {nameFilters && <ErrorComponents error={nameFilters} />}
                            </FormGroup>
                            <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start">
                                <Label htmlFor=" EmailAddress" className="title-font-500 fs-4 text-start text-black">
                                    Email Address *
                                </Label>
                                <input
                                    className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                                    id="email"
                                    {...register("email", {
                                        required: "Email is required *", pattern: {
                                            value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                            message: "Enter valid email"
                                        }
                                    })}
                                    name="email"
                                    placeholder="Enter Email Address..."
                                    type="email"
                                />
                                {errors.email && <ErrorComponents error={errors.email?.message} />}
                            </FormGroup>
                            {
                                button != 'edit' && <>
                                    <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start ">
                                        <Label htmlFor="password" className="title-font-500 fs-4 text-start text-black">
                                            Password *
                                        </Label>
                                        <div className="position-relative d-flex align-items-center">
                                            <input type="text"
                                                className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100 "
                                                id='password' placeholder="Password"
                                                {...register("password", {
                                                    required: "Password is required *",
                                                    minLength: {
                                                        value: 8,
                                                        message: "Password at least 8 characters"
                                                    }
                                                })}

                                            />
                                        </div>
                                        {errors.password && <ErrorComponents error={errors.password?.message} />}
                                    </FormGroup>
                                    <FormGroup className="col-12 col-md-6 col-lg-6 col-xl-6 text-start">
                                        <Label htmlFor="ConfirmPassword" className=" title-font-500 fs-4 text-start text-black">
                                            Confirm Password *
                                        </Label>
                                        <div className="position-relative d-flex align-items-center">
                                            <input type="text" id='password2'
                                                {...register("password2", {
                                                    required: 'The password do not match',
                                                    validate: value => value === password.value || "The password do not match"
                                                })}
                                                placeholder="Re-type Password"
                                                className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100"
                                            />

                                        </div>
                                        {errors.password2 && <ErrorComponents error={errors.password2?.message} />}
                                    </FormGroup>
                                </>
                            }
                            <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                                <Label htmlFor="Role" className=" title-font-500 fs-4 text-start text-black">
                                    Role *
                                </Label>
                                <select id="is_superuser" name="role_type" className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100 ps-3"
                                    {...register("role", { required: "Role is required *" })}>
                                    <option value="user">Staff</option>
                                    <option value="admin">Admin</option>
                                    <option value="superadmin">SuperAdmin</option>
                                </select>
                                {errors.role_type && <ErrorComponents error={"Role is required *"} />}
                            </FormGroup>
                            <FormGroup className="d-flex  flex-column align-items-start w-100 margin-bottom-0">
                                <Label htmlFor="Role" className=" title-font-500 fs-4 text-start text-black">
                                    Default Project *
                                </Label>
                                <select id="is_superuser" name="role_type" className="border-base-color-1 border-radius-10  title-font-500 py-3 px-3 fs-4 w-100 ps-3"
                                    {...register("project", { required: "Project is required *" })}>
                                    <option value="">Select Project</option>
                                    {projectList?.map((data, i) => {
                                        return <option value={data.id} key={i}>{data.name}</option>;
                                    })}
                                </select>
                                {errors.project && <ErrorComponents error={errors.project?.message} />}
                            </FormGroup>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Cancel</span></Button>{' '}
                        <Button className='border-radius-7 p-3 d-flex align-items-center buttons'><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Add</span></Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
};


export default RegistrationModal